import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppBootstrap } from './app/AppBootstrap';
import './shared/design-system/global.css';
import './shared/design-system/refresh.css';

const standalone = window.matchMedia('(display-mode: standalone)').matches
  || (navigator as Navigator & { standalone?: boolean }).standalone === true;
document.documentElement.classList.toggle('is-standalone', standalone);

if (standalone) {
  const getStandaloneScreenHeight = () => {
    const portrait = window.matchMedia('(orientation: portrait)').matches;
    const screenLongSide = Math.max(window.screen.width, window.screen.height);
    const screenShortSide = Math.min(window.screen.width, window.screen.height);
    const orientedScreenWidth = portrait ? screenShortSide : screenLongSide;
    const orientedScreenHeight = portrait ? screenLongSide : screenShortSide;
    const screenMatchesViewport = Math.abs(orientedScreenWidth - window.innerWidth) <= 2;

    return screenMatchesViewport
      ? Math.max(window.innerHeight, orientedScreenHeight)
      : window.innerHeight;
  };

  const syncStandaloneViewportHeight = () => {
    document.documentElement.style.setProperty('--app-viewport-height', `${Math.round(getStandaloneScreenHeight())}px`);
  };
  syncStandaloneViewportHeight();
  window.addEventListener('resize', syncStandaloneViewportHeight);
  window.addEventListener('pageshow', syncStandaloneViewportHeight);
  window.visualViewport?.addEventListener('resize', syncStandaloneViewportHeight);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) syncStandaloneViewportHeight();
  });
  window.requestAnimationFrame(syncStandaloneViewportHeight);
  window.setTimeout(syncStandaloneViewportHeight, 250);
}

const root = document.getElementById('root');
if (!root) throw new Error('Не найден корневой элемент приложения.');

createRoot(root).render(
  <StrictMode>
    <AppBootstrap />
  </StrictMode>
);
